import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { CalendarIcon, ClockIcon, BoxesIcon, LayersIcon, ShoppingBasketIcon, ZapIcon } from 'lucide-react';
export function WhatYouGetSection() {
  const items = [{
    icon: CalendarIcon,
    title: 'Tu Semana Resuelta',
    desc: 'El tablero visual para decidir el domingo y silenciar las dudas el resto de la semana.'
  }, {
    icon: ClockIcon,
    title: 'Sesiones de Alivio',
    desc: 'Cómo preparar tus componentes base en 20 minutos sin vivir en la cocina.'
  }, {
    icon: BoxesIcon,
    title: 'El Kit de Componentes',
    desc: 'La lista definitiva de proteínas, bases y verdes que siempre encajan entre sí.'
  }, {
    icon: LayersIcon,
    title: 'Así se Ensambla',
    desc: 'Inspiración visual para unir tus piezas en segundos según el hambre que tengas.'
  }, {
    icon: ShoppingBasketIcon,
    title: 'La Compra de Componentes',
    desc: 'Una lista optimizada para ir al súper a tiro fijo y comprar solo lo que necesitas.'
  }];
  return <section className="py-12 md:py-24 px-4 bg-warm-100" data-id="element-201">
      <div className="max-w-6xl mx-auto" data-id="element-202">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10 md:mb-16" data-id="element-203">
          <p className="text-sm font-medium text-sage-dark tracking-widest uppercase mb-4" data-id="element-204">
            Qué recibes
          </p>
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold text-warm-900 leading-tight" data-id="element-205">
            Todo lo que necesitas para <br className="hidden md:block" data-id="element-206" />
            <span className="italic text-sage-dark font-medium" data-id="element-207">
              dejar de improvisar
            </span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5" data-id="element-208">
          {items.map((item, i) => {
          const Icon = item.icon;
          return <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-30px'
          }} transition={{
            duration: 0.5,
            delay: i * 0.08
          }} className="bg-white rounded-2xl p-7 border border-warm-200/50 shadow-sm" data-id="element-209">
                <div className="inline-flex p-3 rounded-xl bg-sage/10 text-sage-dark mb-5" data-id="element-210">
                  <Icon className="w-6 h-6" strokeWidth={1.75} data-id="element-211" />
                </div>
                <h3 className="text-xl font-heading font-semibold mb-2 text-warm-900" data-id="element-212">
                  {item.title}
                </h3>
                <p className="text-warm-800/75 leading-relaxed" data-id="element-213">{item.desc}</p>
              </motion.div>;
        })}

          {/* Bonus card */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-30px'
        }} transition={{
          duration: 0.5,
          delay: 0.4
        }} className="bg-warm-900 text-cream rounded-2xl p-7 border border-warm-800 relative overflow-hidden" data-id="element-214">
            <div className="absolute top-4 right-4 px-2.5 py-1 rounded-full bg-gold text-warm-900 text-xs font-bold tracking-wide" data-id="element-215">
              BONUS
            </div>
            <div className="inline-flex p-3 rounded-xl bg-gold/15 text-gold mb-5" data-id="element-216">
              <ZapIcon className="w-6 h-6" strokeWidth={1.75} data-id="element-217" />
            </div>
            <h3 className="text-xl font-heading font-semibold mb-2 text-cream" data-id="element-218">
              El Botón de Pánico
            </h3>
            <p className="text-cream/70 leading-relaxed" data-id="element-219">
              7 soluciones inteligentes para esas noches donde incluso ensamblar
              parece demasiado.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}